import { lazy } from 'react';
import { Route } from 'react-router';
const Introduction = lazy(() => import('@/pages/funnel/products/Introduction'));
const VariantSelection = lazy(() => import('@/pages/funnel/products/VariantSelection'));
const QuantitySelection = lazy(() => import('@/pages/funnel/products/QuantitySelection'));
const Questionnaire = lazy(() => import('@/pages/funnel/questionnaires/Questionnaire'));

export const ProductRoutes = () => (
  <Route path="/products">
    <Route path=":slug/intro" element={<Introduction />} />
    <Route path=":slug/dissolving-tablet" element={<Introduction />} />
    <Route path=":slug/variant-selection" element={<VariantSelection />} />
    <Route path=":slug/quantity-selection" element={<QuantitySelection />} />
    <Route
      path=":slug/user_questionnaires/:questionnaire_id/questions/:id"
      element={<Questionnaire />}
    />
  </Route>
);
